<template>
  <v-expansion-panel
    v-model="componentPanel"
    expand
    class="mt-2">
    <v-expansion-panel-content
      v-for="(component, i) in components"
      :key="component.key"
      :readonly="!component.variants.length"
    >
      <template v-slot:actions>
        <v-icon
          v-if="!component.variants.length || component.selectedVariant"
          color="teal">
          done_all
        </v-icon>
        <div v-if="component.variants.length && !component.selectedVariant">
          <v-chip small>{{ $t('Select options') }}</v-chip>
          <v-icon>
            done
          </v-icon>
        </div>
      </template>
      <template v-slot:header>
        <v-layout
          row
          wrap>
          <v-flex
            xs12
            class="font-weight-bold">{{ component.name }}</v-flex>
          <v-flex
            v-if="component.selectedVariant && component.selectedVariant"
            xs12
            class="caption">
            <span
              v-for="(prop, index) in component.selectedVariant.properties"
              :key="index"
              class="mr-2 grey--text">
              <span class="font-weight-bold">{{ prop.name }}: </span>
              <span>{{ prop.value }}</span>
            </span>
          </v-flex>
        </v-layout>
      </template>
      <v-card>
        <v-card-text>
          <order-draft-item-variants
            :product="component"
            @selected="onBundleVariantSelected(i, $event)"/>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import OrderDraftItemVariants from '@/modules/Orders/components/OrderDraft/OrderDraftItemVariants'
export default {
  name: 'OrderDraftItemBundleSelection',

  components: { OrderDraftItemVariants },

  props: {
    components: {
      required: true,
      type: Array
    }
  },

  data () {
    return {
      componentPanel: 0,
      selectedComponents: this.components
    }
  },

  methods: {
    onBundleVariantSelected (idx, variant) {
      this.selectedComponents[idx].selectedVariant = variant

      for (let i = idx + 1; i < this.selectedComponents.length; i++) {
        if (this.selectedComponents[i].variants &&
          this.selectedComponents[i].variants.length &&
          !this.selectedComponents[i].selectedVariant) {
          this.componentPanel = i
        }
      }

      const selected = this.selectedComponents.filter(c => c.selectedVariant).length
      const toSelect = this.components.filter(c => c.variants && c.variants.length).length
      if (selected === toSelect) {
        this.componentPanel = null
      }

      this.$emit('selected', this.selectedComponents)
    }
  }
}
</script>

<style scoped>

</style>
